import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
} from '@mui/material';
import { useState, useEffect } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { Appointment, NewAppointment } from '../../../types/agendamentos';
import InputLabel from '../../../components/Inputs/InputLabel';

interface AppointmentDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (appointment: NewAppointment) => void;
    selectedDate: Dayjs;
    onDateSelect: (date: Dayjs) => void;
    editingAppointment?: Appointment | null;
}

export default function ModalAgendamento({
    open,
    onClose,
    onSave,
    selectedDate,
    onDateSelect,
    editingAppointment,
}: AppointmentDialogProps) {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [time, setTime] = useState('');
    const [endtime, setEndTime] = useState('');

    useEffect(() => {
        if (editingAppointment) {
            setTitle(editingAppointment.title);
            setDescription(editingAppointment.description);
            setTime(editingAppointment.hora_inicio ? editingAppointment.hora_inicio.substring(0, 5) : '');
        } else {
            setTitle('');
            setDescription('');
            setTime('');
        }
    }, [editingAppointment, open]);

    const handleSave = () => {
        if (!title.trim()) return;

        const appointment: NewAppointment = {
            title: title.trim().toUpperCase(),
            description: description.trim().toUpperCase(),
            data_agendamento: selectedDate.format('YYYY-MM-DD'),
            hora_inicio: time || null,
            hora_fim: endtime || null,
        };

        onSave(appointment);
        handleClose();
    };

    const handleClose = () => {
        setTitle('');
        setDescription('');
        setTime('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 600 }}>
                {editingAppointment ? 'Editar Agendamento' : 'Novo Agendamento'}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <InputLabel
                        id="title"
                        label="Titulo"
                        value={title}
                        setState={setTitle}
                        isUpper
                        next='descricao'
                    />
                    <InputLabel
                        id="descricao"
                        label="Descrição"
                        value={description}
                        setState={setDescription}
                        isUpper
                        next="data_agenda"
                        multiline
                        rows={3}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                        <InputLabel
                            id="data_agenda"
                            label="Data"
                            type="date"
                            value={selectedDate.format("YYYY-MM-DD")}
                            onChange={e => onDateSelect(dayjs(e.target.value))}
                            next="time"
                        />
                        <InputLabel
                            id="time"
                            label="Hora Inicio"
                            type="time"
                            value={time}
                            setState={setTime}
                        />
                        <InputLabel
                            id="time"
                            label="Horá Termino"
                            type="time"
                            value={endtime}
                            setState={setEndTime}
                        />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={handleClose} sx={{ textTransform: 'none' }}>
                    Cancelar
                </Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    disabled={!title.trim()}
                    sx={{ textTransform: 'none' }}
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
